module.exports = __webpack_public_path__ + "img/2.84760d39.png";